import React from "react";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";

// Main component for CBN Deployment for Collectives
export default function Collective() {
  return (
    <>
      {/* Banner section for Agribusiness Stack */}
      <AgribusinessStack
        classname="agriretailer-bg"
        level1="System Integrator"
        level2="Agribusiness"
        level3="Collectives"
      />

      {/* Section representing deployment for collectives */}
      <SolutionEcosystem
        title="CBN Deployment for Collectives"
        type="LTN"
        bodycopy="LTN is a type of CBN Network for collectives to do local trade & local distribution with farmers."
      />
    </>
  );
}

